// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const btoaEncoded = (value: any) => {
  let valueData = value;
  if (typeof value === 'object') {
    valueData = JSON.stringify(value);
  }
  return btoa(valueData);
};

export const atobDecode = <T>(value: string, isObject = false) => {
  const decodedValue = atob(value);
  if (isObject) {
    return JSON.parse(decodedValue) as T;
  }
  return decodedValue as T;
};
